import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { USER_ROLE } from '../../../core/constants/user-role.enum';
import { ViewDetails } from '../../../core/models/view-details.model';
import { LoggedInUserService } from '../../../core/services/logged-in-user.service';
import { RoutingHandlerService } from '../../../core/services/routing-handler.service';
import { SidebarMenuService } from '../../../core/services/sidebar-menu.service';

@Component({
    selector: 'app-back-btn',
    templateUrl: './back-btn.component.html',
    styleUrls: ['./back-btn.component.css']
})
export class BackBtnComponent implements OnInit {
    userRole: USER_ROLE;
    viewDetails: ViewDetails;

    constructor(
        private routingHandlerService: RoutingHandlerService,
        private loggedInUserService: LoggedInUserService,
        private sidebarMenuService: SidebarMenuService,
        private location: Location
    ) {}

    ngOnInit(): void {
        this.getViewAndUserRole();
    }

    getViewAndUserRole() {
        this.userRole = this.loggedInUserService.getUserRole();
        this.viewDetails = this.sidebarMenuService.getViewObject();
    }

    navigateBackToList() {
        // this.routingHandlerService.navigateBackToList(this.userRole, this.viewDetails);
        this.location.back();
    }
}
